import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DragDropDirective } from '../../../shared/drag-drop/drag-drop.directive';

@Component({
    selector: 'app-upload-file',
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DragDropDirective]
})
export class UploadFileComponent {
  @Input() accept: string = null;
  @Output() fileChange = new EventEmitter<File>();
  @ViewChild('fileInput') fileInput: ElementRef;

  constructor() { }

  uploadFile(fileList: File[]): void {
    if (fileList?.length > 0) {
      this.fileChange.emit(fileList[0]);
      this.fileInput.nativeElement.value = '';
    }
  }
}
